var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsRemoveRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1428 0.863868C10.8828 0.603868 10.4628 0.603868 10.2029 0.863868L6.00004 5.06001L1.79723 0.857201C1.53723 0.597201 1.11723 0.597201 0.857231 0.857201C0.597231 1.1172 0.597231 1.5372 0.857231 1.7972L5.06004 6.00001L0.857231 10.2028C0.597231 10.4628 0.597231 10.8828 0.857231 11.1428C1.11723 11.4028 1.53723 11.4028 1.79723 11.1428L6.00004 6.94001L10.2029 11.1428C10.4628 11.4028 10.8828 11.4028 11.1428 11.1428C11.4029 10.8828 11.4029 10.4628 11.1428 10.2028L6.94004 6.00001L11.1428 1.7972C11.3962 1.54387 11.3962 1.1172 11.1428 0.863868Z",
    fill: "#F00022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsRemoveRed);
export default __webpack_public_path__ + "static/media/icons-remove-red.033596cef06143ae440af6ecdbfd2dfb.svg";
export { ForwardRef as ReactComponent };